import {
  Component,
  ContentChild,
  DoCheck,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  forwardRef,
  inject,
  input,
} from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { NavbarSecondaryMenuComponent } from '../navbar-secondary-menu/navbar-secondary-menu.component';
import { NavbarMenuItemLabelDirective } from './navbar-menu-item-label.directive';

@Component({
  selector: 'di-navbar-menu-item',
  templateUrl: './navbar-menu-item.component.html',
  standalone: false,
  host: {
    class: 'tw:whitespace-nowrap',
  },
})
export class NavbarMenuItemComponent implements DoCheck {
  @Input() label = '';
  @Input() href?: string;
  @Input() isHidden? = false;
  @Input() isDisabled? = false;
  @Input() tooltipText?: TemplateRef<unknown>;
  public readonly isExternalLink = input<boolean>();

  // eslint-disable-next-line
  @Output() readonly click = new EventEmitter<MouseEvent>();

  /** @ignore */
  @ViewChild('content', { read: TemplateRef })
  readonly content!: TemplateRef<unknown>;

  /** @ignore */
  @ViewChild('secondary', { read: TemplateRef })
  readonly secondary!: TemplateRef<unknown>;

  /** @ignore */
  @ContentChild(NavbarMenuItemLabelDirective)
  readonly labelDirective?: NavbarMenuItemLabelDirective;
  /** @ignore */
  @ContentChild(TemplateRef) readonly labelTmp?: TemplateRef<unknown>;
  /** @ignore */
  @ContentChild(forwardRef(() => NavbarSecondaryMenuComponent))
  public readonly secondaryMenu?: NavbarSecondaryMenuComponent;
  /** @ignore */
  protected readonly elRef: ElementRef<HTMLElement> = inject(ElementRef);
  /** @ignore */
  private readonly routerLinkActive = inject(RouterLinkActive, {
    optional: true,
    self: true,
  });

  /** @ignore */
  private _routerLinkActive: boolean | null = null;
  /** @ignore */
  private _active = new BehaviorSubject(false);

  readonly isActive$ = this._active.asObservable();
  readonly isActive = () => this._active.getValue();

  @Input() set active(value: boolean) {
    this._active.next(value);
  }

  /** @ignore */
  ngDoCheck(): void {
    if (this.routerLinkActive && this.routerLinkActive.isActive !== this._routerLinkActive) {
      this._routerLinkActive = this.routerLinkActive.isActive;
      this._active.next(this._routerLinkActive);
    }
  }
}
